import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { CoursesNavbar } from "./Components/Navbar/Navbar";
import { Filter } from "./Components/filter/filter";
import { CourseCard } from "./Components/CourseCard/CourseCard";
import { SearchBars } from "./Components/SearchBars/SearchBars";
import { useParams } from "react-router-dom";
import "./DisplayCourses.css"; // Import CSS

export const DisplayCourses = () => {
  const [id, setId] = useState("");
  const [viewMode, setViewMode] = useState("list"); // 'grid' or 'list'
  const paramsId = useParams();

  useEffect(() => {
    if (paramsId) {
      setId(paramsId);
    } else {
      setId(null);
    }
  }, [paramsId]);

  return (
    <Box className="courses-container">
      {/* Navbar */}
      <CoursesNavbar viewMode={viewMode} setViewMode={setViewMode} />

      {/* Search Bar */}
      <Box className="searchnew-container">
        <SearchBars />
      </Box>

      {/* Main Content */}
      <Box>
        <div className="content-container" style={{ maxWidth: "1004px" }}>
          {/* Filter */}
          {/*    <Box className="filter-container"><Filter /></Box>*/}

          {/* Courses */}
          <Box className="courses-list">
            <CourseCard 
              idd={id} 
              viewMode={viewMode === 'list' && window.innerWidth < 600 ? 'grid' : viewMode} 
            />
          </Box>
        </div>
      </Box>
    </Box>
  );
};
